/**
 * @file: storeFeatureAccess.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StoreEntitlement } from '@euler/model';
import { StoreFeature } from '@euler/model/enum';

export interface StoreFeatureAccess {
  enabled: boolean;
  /** Held only through a trial: when it ends. */
  trialEndsAt: string | null;
}

const kUnknown: StoreFeatureAccess = { enabled: true, trialEndsAt: null };
const kMissing: StoreFeatureAccess = { enabled: false, trialEndsAt: null };

/**
 * Whether the profile's entitlements give the feature (granted, or on a
 * trial, which stays a trial). They list every feature the store has: one
 * its edition's line includes but the store has switched off is missing,
 * and the server refuses it. A profile without entitlements (an older
 * build's saved profile, an older server) hides nothing: the server refuses
 * what the store lacks either way.
 */
export function storeFeatureAccessOf(
  entitlements: readonly StoreEntitlement[] | undefined,
  feature: StoreFeature,
): StoreFeatureAccess {
  if (entitlements == null) return kUnknown;
  const found = entitlements.find(x => x.feature === feature);
  return found == null
    ? kMissing
    : { enabled: true, trialEndsAt: found.trialEndsAt };
}
